import { render, staticRenderFns } from "./printSettingTutorial.vue?vue&type=template&id=548adda2&"
import script from "./printSettingTutorial.vue?vue&type=script&lang=ts&"
export * from "./printSettingTutorial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports